import { render, staticRenderFns } from "./MatchInfo.vue?vue&type=template&id=47647526&scoped=true&"
import script from "./MatchInfo.vue?vue&type=script&lang=js&"
export * from "./MatchInfo.vue?vue&type=script&lang=js&"
import style0 from "@/tbs/stylesheet/dynamic.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./MatchInfo.vue?vue&type=style&index=1&id=47647526&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47647526",
  null
  
)

export default component.exports